'use client'

import { useScrollAnimation } from '@/hooks/useScrollAnimation'
import { useSafeTranslations } from '@/hooks/useSafeTranslations'
import './Intro.css'

export default function Intro() {
  const sectionRef = useScrollAnimation<HTMLElement>({
    threshold: 0.1,
    rootMargin: '0px 0px 150px 0px'
  })

  // Get translations using safe hook (handles i18n context automatically)
  const t = useSafeTranslations('intro')


  return (
    <section className="intro" data-animate-on-scroll ref={sectionRef}>
      <div className="container">
        <div className="intro-header" data-scroll-item>
          <p className="intro-meta">
            <strong>{t('meta')}</strong> / {t('established')}
          </p>
        </div>
        <div className="intro-content" data-scroll-item>
          <p className="intro-text">
            {t('text')}
          </p>
        </div>
      </div>
    </section>
  )
}
